<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="workspace_premium_black_24dp 1" clip-path="url(#clip0_2173_25216)">
<path id="Vector" d="M6.45366 9.12732L8.00033 7.95398L9.54033 9.12732L8.95366 7.22732L10.5003 6.00065H8.60699L8.00033 4.12732L7.39366 6.00065H5.50033L7.04033 7.22732L6.45366 9.12732ZM13.3337 6.66732C13.3337 3.72065 10.947 1.33398 8.00033 1.33398C5.05366 1.33398 2.66699 3.72065 2.66699 6.66732C2.66699 8.02065 3.17366 9.24732 4.00033 10.1873V15.334L8.00033 14.0007L12.0003 15.334V10.1873C12.827 9.24732 13.3337 8.02065 13.3337 6.66732ZM8.00033 2.66732C10.207 2.66732 12.0003 4.46065 12.0003 6.66732C12.0003 8.87398 10.207 10.6673 8.00033 10.6673C5.79366 10.6673 4.00033 8.87398 4.00033 6.66732C4.00033 4.46065 5.79366 2.66732 8.00033 2.66732Z" fill="#93182F"/>
</g>
<defs>
<clipPath id="clip0_2173_25216">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
